import { gql } from '@apollo/client';

export const GROUP_BASE_FIELDS = gql`
  fragment GroupBaseFields on Group {
    id
    active
    name
    enterprise_classification
    guided_readiness
    client_code
    sectors
  }
`;
